import { useSwipeable } from 'react-swipeable';
import { Button } from '@ais-ui/ui-core';
import { formatVesselName } from '@ais-ui/utils';
import { XIcon } from 'lucide-react';
import { useSelectionState } from '../SelectionStateProvider';
import { TargetCardContent } from '../../modules/Targets/TargetCardContent';
import { TargetProvider } from '../../modules/Targets/TargetContext';

interface VesselDetailsMobileViewProps {
  onClose: () => void;
}

export const VesselDetailsMobileView = ({
  onClose,
}: VesselDetailsMobileViewProps) => {
  const { currentTargetInfo } = useSelectionState();

  // Swipe right to close
  const handlers = useSwipeable({
    onSwipedRight: () => onClose(),
    trackMouse: false,
    preventScrollOnSwipe: false,
    delta: 50, // Minimum swipe distance
  });

  // Get vessel name for header
  const vesselName = currentTargetInfo
    ? 'name' in currentTargetInfo
      ? currentTargetInfo.name
      : 'basic' in currentTargetInfo &&
          currentTargetInfo.basic &&
          'vesselName' in currentTargetInfo.basic
        ? currentTargetInfo.basic.vesselName
        : 'Vessel Details'
    : 'Vessel Details';

  return (
    <div
      {...handlers}
      className="fixed inset-0 z-50 bg-background flex flex-col overflow-hidden"
    >
      {/* Sticky Header */}
      <header className="sticky top-0 z-10 bg-background border-b px-4 py-3 flex items-center justify-between shadow-sm">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="shrink-0"
        >
          <XIcon className="h-6 w-6" />
        </Button>
        <h1 className="text-lg font-semibold truncate flex-1 text-center mx-2">
          {formatVesselName(vesselName) || 'Vessel Details'}
        </h1>
        {/* Spacer for symmetry */}
        <div className="w-10 shrink-0"></div>
      </header>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        <TargetProvider isExpanded={true} setIsExpanded={() => {}}>
          <div className="w-full">
            <TargetCardContent />
          </div>
        </TargetProvider>
      </div>
    </div>
  );
};
